import axios from 'axios'
import { Message } from 'element-ui'
import config from '../config/env.js'

// 创建axios实例
const service = axios.create({
  baseURL: config.baseUrl, // api的base_url
  timeout: config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('API响应:', res)
    
    // 检查业务状态码 - 支持字符串"200"和数字200
    if (res.code === 200 || res.code === '200') {
      return res
    } else {
      const errorMsg = res.message || res.msg || '请求失败'
      Message({
        message: errorMsg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    console.log('err' + error)
    const errorMsg = error.response?.data?.message || error.message || '网络请求失败'
    Message({
      message: errorMsg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service 